import React, { useState, useEffect, createContext } from "react";
import jsDig from "utils/jsDig.js";
import AccountSettingsModal from "./AccountSettingsModal";

export const SettingsContext = createContext();

export default function AccountSettingsButton(props) {
  const dataPullErrors = jsDig(["data_pull_errors"], props).length;
  let cog = require("images/lite/icons/settings.png");
  cog = <img className={`settings-cog ${dataPullErrors > 0 ? "errors-present" : ""}`} alt="Settings" src={`/datapulse${cog}`} />;
  let alerts = props.alerts.length
  let bell = require("images/lite/icons/bell.png");
  bell = <a href="/datapulse/alerts" className="alert-icon-link">
          <div className="alert-icon-container">
            <img className="alert-icon filter-grey" width="28" src={`/datapulse${bell}`} alt="icon" />
            <span className="alert-number">{alerts}</span>
          </div>
         </a>

  const [isModalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!isModalOpen);


  //Users
  const [clientUsers, setClientUsers] = useState(props.users ? props.users.clients : []);
  const [teamUsers, setTeamUsers] = useState(props.users ? props.users.employees : []);

  //Basic Tab
  const [companyName, setCompanyName] = useState(props.company_name);
  const [baseCurrency, setBaseCurrency] = useState(jsDig(["client_account", "base_currency"], props));
  const [displayCurrency, setDisplayCurrency] = useState(jsDig(["client_account", "display_currency"], props));
  const [defaultObjective, setDefaultObjective] = useState(jsDig(["client_account", "dashboard_objective"], props));
  const [overviewDatasource, setOverviewDatasource] = useState(jsDig(["client_account", "overview_datasource"], props));
  const [website, setWebsite] = useState(jsDig(["client_account", "website"], props));
  const [clientLogo, setClientLogo] = useState(props.client_logo);
  const [clientLogoUrl, setClientLogoUrl] = useState(props.client_logo);

  //Account Ids
  const [facebookObjective, setFacebookObjective] = useState(jsDig(["social_section", "conversion_objective"], props));
  const [tiktokObjective, setTiktokObjective] = useState(jsDig(["social_section", "tiktok_conversion_objective"], props));
  const [semrushTargetLocation, setSemrushTargetLocation] = useState(jsDig(["seo_section", "semrush_target_location"], props));
  const [shopifyRevenueType, setShopifyRevenueType] = useState(jsDig(["ppc_section", "shopify_revenue_type"], props)); // This is actually more accurately called Shopify Sales Channel
  const [shopifyCountryFilter, setShopifyCountryFilter] = useState(jsDig(["ppc_section", "shopify_country_filter"], props));
  const [googleAdsId, setGoogleAdsId] = useState(jsDig(["client_account", "platform_ids", "google_ads"], props));
  const [googleAdsCustomConversionsEnabled, setGoogleAdsCustomConversionsEnabled] = useState(jsDig(["google_ads_custom_conversions_enabled"], props) || false);
  const [googleAdsCustomConversions, setGoogleAdsCustomConversions] = useState(jsDig(["google_ads_custom_conversions"], props) || []);
  const [googleAdsCampaignFiltersEnabled, setGoogleAdsCampaignFiltersEnabled] = useState(jsDig(["google_ads_campaign_filters_enabled"], props) || false);
  const [googleAdsCampaignFilters, setGoogleAdsCampaignFilters] = useState(jsDig(["google_ads_campaign_filters"], props) || []);
  const [microsoftId, setMicrosoftId] = useState(jsDig(["client_account", "platform_ids", "microsoft_ads"], props));
  const [metaId, setMetaId] = useState(jsDig(["client_account", "platform_ids", "meta_ads"], props));
  const [metaAdsCustomConversions, setMetaAdsCustomConversions] = useState(jsDig(["social_section", "custom_conversions"], props) || []);
  const [tiktokId, setTiktokId] = useState(jsDig(["client_account", "platform_ids", "tiktok_ads"], props));
  const [googleAnalyticsId, setGoogleAnalyticsId] = useState(jsDig(["client_account", "platform_ids", "google_analytics"], props));
  const [searchConsoleProperty, setSearchConsoleProperty] = useState(jsDig(["client_account", "platform_ids", "search_console"], props));
  const [brandedRegex, setBrandedRegex] = useState(jsDig(["client_account", "branded_regex"], props));
  const [semrushId, setSemrushId] = useState(jsDig(["client_account", "platform_ids", "semrush"], props));
  const [shopifyUrl, setShopifyUrl] = useState(jsDig(["client_account", "shopify_url"], props));
  const [amazonAdsId, setAmazonAdsId] = useState(jsDig(["client_account", "platform_ids", "amazon_ads"], props));
  const [amazonSellerCountry, setAmazonSellerCountry] = useState("US");
  const [googleSheetsUrl, setGoogleSheetsUrl] = useState(jsDig(["client_account", "platform_ids", "google_sheets_url"], props));
  const [mailchimpServerPrefix, setMailchimpServerPrefix] = useState(jsDig(["client_account", "platform_ids", "mailchimp_server_prefix"], props));
  const [pinterestAdsId, setPinterestAdsId] = useState(jsDig(["client_account", "platform_ids", "pinterest_ads"], props));
  const [klaviyoApiKey, setKlaviyoApiKey] = useState(jsDig(["client_account", "platform_ids", "klaviyo_api_key"], props));
  const [klaviyoConversionMetric, setKlaviyoConversionMetric] = useState(jsDig(["client_account", "klaviyo_conversion_metric"], props));
  const [metaAdsAttributionType, setMetaAdsAttributionType] = useState(jsDig(["social_section", "meta_ads_attribution_type"], props));
  const [metaAdsCampaignFilter, setMetaAdsCampaignFilter] = useState(jsDig(["social_section", "pull_campaign_name_only"], props));
  const [shopifyRevenueMetric, setShopifyRevenueMetric] = useState(jsDig(["ppc_section", "shopify_revenue_metric"], props));


  // Google Ads Scripts
  const [googleAdsScripts, setGoogleAdsScripts] = useState(jsDig(["client_account", "google_ads_scripts"], props) || {});

  // DataPulse Scripts
  const [dataPulseScripts, setDataPulseScripts] = useState(jsDig(["client_account", "datapulse_scripts"], props) || {});

  // All Script Variables
  const [scriptVariables, setScriptVariables] = useState(jsDig(["client_account", "script_variables"], props) || {});

  //inflation
  const [inflation, setInflation] = useState(props.search_section.daily_yields);

  const contextValue = {
    isModalOpen,
    toggleModal,
    clientUsers,
    setClientUsers,
    teamUsers,
    setTeamUsers,
    companyName,
    setCompanyName,
    website,
    setWebsite,
    defaultObjective,
    setDefaultObjective,
    overviewDatasource,
    setOverviewDatasource,
    baseCurrency,
    setBaseCurrency,
    displayCurrency,
    setDisplayCurrency,
    clientLogo,
    setClientLogo,
    clientLogoUrl,
    setClientLogoUrl,
    googleAnalyticsId,
    setGoogleAnalyticsId,
    searchConsoleProperty,
    setSearchConsoleProperty,
    brandedRegex,
    setBrandedRegex,
    googleAdsId,
    setGoogleAdsId,
    googleAdsCustomConversionsEnabled,
    setGoogleAdsCustomConversionsEnabled,
    googleAdsCustomConversions,
    setGoogleAdsCustomConversions,
    googleAdsCampaignFiltersEnabled,
    setGoogleAdsCampaignFiltersEnabled,
    googleAdsCampaignFilters,
    setGoogleAdsCampaignFilters,
    metaId,
    setMetaId,
    metaAdsCustomConversions,
    setMetaAdsCustomConversions,
    facebookObjective,
    setFacebookObjective,
    microsoftId,
    setMicrosoftId,
    tiktokId,
    setTiktokId,
    tiktokObjective,
    setTiktokObjective,
    semrushId,
    setSemrushId,
    semrushTargetLocation,
    setSemrushTargetLocation,
    shopifyRevenueType,
    setShopifyRevenueType,
    shopifyCountryFilter,
    setShopifyCountryFilter,
    shopifyUrl,
    setShopifyUrl,
    amazonAdsId,
    setAmazonAdsId,
    amazonSellerCountry,
    setAmazonSellerCountry,
    googleSheetsUrl,
    setGoogleSheetsUrl,
    mailchimpServerPrefix,
    setMailchimpServerPrefix,
    googleAdsScripts,
    setGoogleAdsScripts,
    dataPulseScripts,
    setDataPulseScripts,
    scriptVariables,
    setScriptVariables,
    inflation,
    setInflation,
    pinterestAdsId,
    setPinterestAdsId,
    klaviyoApiKey,
    setKlaviyoApiKey,
    klaviyoConversionMetric,
    setKlaviyoConversionMetric,
    metaAdsAttributionType,
    setMetaAdsAttributionType,
    metaAdsCampaignFilter,
    setMetaAdsCampaignFilter,
    shopifyRevenueMetric,
    setShopifyRevenueMetric,
    ...props,
  };

  return (
    <SettingsContext.Provider value={contextValue}>
      <div className="account-settings-button-row">
        <button id="account-settings-button" className={`button b-type-secondary b-size-normal ${dataPullErrors > 0 ? "errors-present-border" : ""} account-settings  get-account-settings`} onClick={toggleModal}>
          {cog}
          <p>Account Settings</p>
        </button>
        {alerts > 0 && props.organization.name == "Digital Position" &&
          bell
        }
      </div>
      <AccountSettingsModal />
    </SettingsContext.Provider>
  );
}
